function getDiscussionEntityFlagsFromSupplyChain(entity, supplyChainMatches, ubiquitySupplyChainMatches) {

  const supplyChainToUse = supplyChainMatches.length > 0 ? supplyChainMatches : ubiquitySupplyChainMatches;

    const consulatedSupplyChainMatchesFlags = supplyChainToUse?.map(match => match.flags)?.flat()?.filter((obj, index, self) => {
      return index === self.findIndex((t) => (
        t?.trim() === obj?.trim()
      ));
    })
    ?.filter(flag => flag !== undefined)
    ?.sort(function (a, b) {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
  //console.log("consulatedSupplyChainMatchesFlags", consulatedSupplyChainMatchesFlags)
  const consulatedSupplyChainMatchesProcessorFlags = supplyChainToUse?.map(match => match.processor_flags)?.flat()?.filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t?.trim() === obj?.trim()
    ));
  })
  ?.filter(flag => flag !== undefined)
  ?.sort(function (a, b) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  });
  //console.log("consulatedSupplyChainMatchesProcessorFlags", consulatedSupplyChainMatchesProcessorFlags)
  const consulatedSupplyChainMatchesVesselFlagsUnique = supplyChainToUse?.map(match => match.vessel_flags)?.flat()?.filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t?.trim() === obj?.trim()
    ));
  })
  ?.filter(flag => flag !== undefined)
  ?.sort(function (a, b) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  });
  //console.log("consulatedSupplyChainMatchesVesselFlagsUnique", consulatedSupplyChainMatchesVesselFlagsUnique)

  /*
  const consulatedUbiquitySupplyChainMatchesFlags = ubiquitySupplyChainMatches?.map(match => match.flags)?.flat()?.filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t?.trim() === obj?.trim()
    ));
  }
  )?.filter(flag => flag !== undefined)
  ?.sort(function (a, b) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  }) || [];

  const consulatedUbiquitySupplyChainMatchesProcessorFlags = ubiquitySupplyChainMatches?.map(match => match.processor_flags)?.flat()?.filter((obj, index, self) => {
    return index === self.findIndex((t) => (
      t?.trim() === obj?.trim()
    ));
  }
  )?.filter(flag => flag !== undefined)
  ?.sort(function (a, b) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  }) || [];
  */

  const finalProcessorFlags = [...consulatedSupplyChainMatchesProcessorFlags, ...entity.discussion_flags]


  return {
    flags: consulatedSupplyChainMatchesFlags,
    processor_flags: finalProcessorFlags,
    vessel_flags: consulatedSupplyChainMatchesVesselFlagsUnique
  
  };
}

export default getDiscussionEntityFlagsFromSupplyChain;